import React, { useEffect, useRef, useState } from "react";
import { Button, Form, message, Spin } from "antd";
import "./DetailPatient.scss";
import MedicalHistory from "./components/MedicalHistory/MedicalHistory";
import PatientInfo from "./components/PatientInfo/PatientInfo";
import { StepInfo } from "components/common";
import NurseInfo from "./components/NurseInfo/NurseInfo";
import MedicineSearch from "./components/MedicineSearch/MedicineSearch";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { TEN_PHONG, TT_PHIEU_KHAM, tabKeys } from "types/enums";
import Icon from "assets/icons";
import {
  setActiveKey,
  setButtonsHeader,
  setIdPhieuKham,
} from "redux/reducer/common";
import { nurseOutService, examinationService } from "api";
import {
  setCallApiList,
  setDetailPhieu,
  setIdPhieu,
  setIdReceiptNurseOut,
  setlistThuocTraMat,
} from "redux/reducer/nurseOut";
import {
  Cancel,
  Completed,
  CompletedKCB,
  NextPatient,
  Pause,
  Save,
  SaveAndPrint,
} from "./components/ListButton/ListButton";
import Notification from "components/common/notification/notification";
import {
  disableBtn,
  dispatchCurrentRoom,
  parseValueOfObjectToJson,
} from "helper/common";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import NurseOutModal from "components/common/PrintReceipt/NurseOutModal/NurseOutModal";
import CheckNullApi from "components/common/CheckNullApi/CheckNullApi";
import { ModalConfirm } from "./components/ModalConfirm/ModalConfirm";
import AlertModal from "components/common/AlertModal/AlertModal";
const DetailPatient = () => {
  // const [detailPhieu, setDetailPhieu] = useState<any>(null);
  const modalRef = useRef<any>();
  const [listButton, setListButton] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const activeKey = useAppSelector((state) => state.common.activeTab);
  const idPhieu = useAppSelector((state) => state.nurseOut.idPhieu);
  const activeTab = useAppSelector((state) => state.common.activeTab);
  const medicalHistoryRef = useRef<any>(null);
  const patientInfoRef = useRef<any>();
  const nurseInfoRef = useRef<any>();
  const modalConfirmRef = useRef<any>();
  const [loading, setLoading] = useState(false);
  const modalAlertRef = useRef<any>();
  const detailPhieu = useAppSelector((state) => state.nurseOut.detailPhieu);
  const [idPhong, setIdPhong] = useState();

  useEffect(() => {
    if (activeTab != tabKeys.NURSE_OUT.DETAIL_PATIENT) {
      dispatch(setButtonsHeader([]));
      dispatch(setDetailPhieu(null));
    } else {
      getNurseForm(idPhieu);
    }
  }, [activeTab]);
  const navigateToTabList = () => {
    dispatch(setCallApiList(true));
    dispatch(setActiveKey(tabKeys.NURSE_OUT.LIST_PATIENT));
  };
  const handleCompleteKCB = async () => {
    await handleSave();
    try {
      const res = await examinationService.completeKCB(
        detailPhieu?.idPhieuKham
      );
      Notification("success", "Đã hoàn thành khám chữa bệnh");
    } catch (error) {
      Notification("error", "Đã có lỗi khi hoàn thành khám chữa bệnh");
    }
    // await postStatusNurseForm(TT_PHIEU_KHAM.HT);
    navigateToTabList();
  };
  const handleSave = async () => {
    await updateDetailPhieu();
  };
  const handleSaveAndPrint = async () => {
    dispatch(setIdReceiptNurseOut(null));
    await updateDetailPhieu();
    dispatch(setIdReceiptNurseOut(idPhieu));
    modalRef.current?.openModal();
  };
  const handleComplete = async () => {
    const infPatient = patientInfoRef.current?.getFormValue();
    const res = disableBtn(infPatient.ngayTao);
    if (res) {
      modalAlertRef.current.openModal();
      setLoading(false);
      return;
    }
    await patientInfoRef?.current?.validateFields();
    await handleSave();
    await postStatusNurseForm(3);
    navigateToTabList();
  };
  const openModal = () => {
    modalConfirmRef.current.openModal();
  };

  const handleNextPatient = async () => {
    await getNextPatient();

    // await postStatusNurseForm(2);

    // handle nextBenhNhan
  };
  const handlePause = async () => {
    if (detailPhieu?.trangThai == 2) {
      await postStatusNurseForm(1);
      navigateToTabList();
    } else {
      Notification(
        "warning",
        "Chỉ tạm dừng khi phiếu ở trạng thái Đang thực hiện"
      );
    }
  };
  const handleCancel = async () => {
    await postStatusNurseForm(6);
    navigateToTabList();
  };
  const getNextPatient = async () => {
    try {
      const res = await nurseOutService.getNextPatient();
      dispatch(setIdPhieu(res));
      await getNurseForm(res);
    } catch (error) {
      if (error?.response?.data == "Đã hết bệnh nhân trong danh sách") {
        Notification("info", "Đã hết bệnh nhân trong danh sách");
      }
    }
  };
  const updateDetailPhieu = async () => {
    setLoading(true);
    let data = getFormValue();
    if (data?.phong == null) {
      data = { ...data, phong: 5 };
    }

    try {
      const res = await nurseOutService.updateNurseForm(data);
      console.log(res);
      dispatch(setDetailPhieu(res));
      setLoading(false);
      dispatch(setCallApiList(true));
      Notification("success", "Đã lưu thông tin phiếu điều dưỡng");
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra");
    }
  };
  const postStatusNurseForm = async (trangThai) => {
    setLoading(true);
    try {
      const params = {
        id: idPhieu,
        trangThai: trangThai,
      };
      const res = await nurseOutService.postStatusNurseForm(params);
      // setDetailPhieu(res);
      console.log(res);
      dispatch(
        setDetailPhieu({
          ...res,
          jsonDieuDuongDto: getFormValue()?.jsonDieuDuongDto,
        })
      );
      setLoading(false);
      let message = "";
      if (trangThai == 1) {
        message = "Đã cập nhật phiếu thành trạng thái Chờ thực hiện";
      }
      if (trangThai == 2) {
        message = "Đã cập nhật phiếu thành trạng thái Đang thực hiện";
      }
      if (trangThai == 3) {
        message = "Đã cập nhật phiếu thành trạng thái Hoàn thành";
      }
      if (trangThai == 6) {
        message = "Đã cập nhật phiếu thành trạng thái Hủy thực hiện";
      }

      Notification("success", message);
    } catch (error) {
      setLoading(false);

      Notification("error", "Đã có lỗi xảy ra");
    }
  };

  const getListDilate = async () => {
    try {
      const res = await nurseOutService.getListDilate();
      dispatch(setlistThuocTraMat(res));
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách thuốc tra mắt");
    }
  };

  const getFormValue = () => {
    const medicalHistoryValue = medicalHistoryRef.current?.getFormValue();
    const nurseInfoValue = nurseInfoRef.current?.getFormValue();
    const patientInfoValue = patientInfoRef.current?.getFormValue();

    parseValueOfObjectToJson(medicalHistoryValue);
    parseValueOfObjectToJson(nurseInfoValue);

    const jsonDieuDuongDto = {
      idPhieuDieuDuong: idPhieu,
      ...medicalHistoryValue,
      ...nurseInfoValue,
      // foodAllergies: {},
      drugAllergies: {},
    };
    const data = {
      ...detailPhieu,
      ...patientInfoValue,
      jsonDieuDuongDto: jsonDieuDuongDto,
      id: idPhieu,
    };
    return data;
  };

  const getNurseForm = async (id) => {
    if (id != null) {
      setLoading(true);
      try {
        const res = await nurseOutService.getNurseForm(id);
        console.log(res);
        setLoading(false);
        dispatch(setDetailPhieu(res));
        console.log(res);
        // setJsonNurse(res?.jsonDieuDuongDto);
      } catch (error) {
        setLoading(false);
        Notification("error", "Đã có lỗi khi lấy thông tin phiếu");
      }
    }
  };

  useEffect(() => {
    getListDilate();
  }, []);

  useEffect(() => {
    setListButton([
      CompletedKCB(handleCompleteKCB),
      Save(handleSave, detailPhieu?.trangThai),
      SaveAndPrint(handleSaveAndPrint, detailPhieu?.trangThai),
      Completed(openModal, detailPhieu?.trangThai),
      // NextPatient(handleNextPatient, detailPhieu?.trangThai),
      Cancel(handleCancel, detailPhieu?.trangThai),
      Pause(handlePause, detailPhieu?.trangThai),
    ]);
    if (detailPhieu?.trangThai == TT_PHIEU_KHAM.CTH) {
      postStatusNurseForm(TT_PHIEU_KHAM.DTH);
    }
    dispatch(setIdPhieuKham(detailPhieu?.idPhieuKham));
    dispatchCurrentRoom(dispatch, detailPhieu?.trangThai, TEN_PHONG.dieu_duong);
  }, [detailPhieu]);

  useEffect(() => {
    if (
      listButton.length > 0 &&
      activeKey == tabKeys.NURSE_OUT.DETAIL_PATIENT
    ) {
      dispatch(setButtonsHeader(listButton));
    }
  }, [listButton]);
  useEffect(() => {
    if (activeKey != tabKeys.NURSE_OUT.DETAIL_PATIENT) {
      dispatch(setButtonsHeader([]));
    }
  }, [activeKey]);

  useEffect(() => {
    if (!idPhieu) {
      dispatch(setActiveKey(tabKeys.NURSE_OUT.LIST_PATIENT));
    }
  }, []);

  //check xem có đủ api chưa?
  useEffect(() => {
    CheckNullApi();
  }, []);
  return (
    <Spin spinning={loading}>
      <div className="detail-patient">
        <div className="container">
          <div className="header">Thông tin bệnh nhân</div>
          <div className="container-main">
            <PatientInfo ref={patientInfoRef}></PatientInfo>
          </div>
        </div>
        <div className="container">
          <StepInfo></StepInfo>
        </div>

        <div className="container">
          {/* <div className="header">Bệnh sử</div> */}
          <div className="container-main">
            {detailPhieu && (
              <MedicalHistory ref={medicalHistoryRef}></MedicalHistory>
            )}
          </div>
        </div>

        <div className="container">
          <div className="header">Thông tin điều dưỡng</div>
          <div className="container-main">
            <NurseInfo ref={nurseInfoRef}></NurseInfo>
          </div>
        </div>

        <div className="container">
          <div className="header">Tra thuốc</div>
          <div className="container-main">
            <MedicineSearch idPhieu={idPhieu}></MedicineSearch>
          </div>
        </div>
        <ModalCustom ref={modalRef} width={1000} centered>
          <NurseOutModal></NurseOutModal>
        </ModalCustom>
        <ModalCustom
          ref={modalConfirmRef}
          centered
          width={600}
          title="Xác nhận chuyển phòng"
          onOpenModal={() => {
            setIdPhong(patientInfoRef?.current?.getFormValue()?.phong);
          }}
        >
          <ModalConfirm
            onConfirm={handleComplete}
            idPhong={idPhong}
          ></ModalConfirm>
        </ModalCustom>

        {/* Cảnh báo đã quá ngày hoàn thành */}
        <ModalCustom ref={modalAlertRef} width={600} title={"Cảnh báo"}>
          <AlertModal
            message={
              "Đã quá hạn hoàn thành cho phiếu khám. Vui lòng chọn hoàn thành khám chữa bệnh để hoàn thành phiếu!"
            }
          />
        </ModalCustom>
      </div>
    </Spin>
  );
};
export default DetailPatient;
